import { Component, ElementRef, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ConfirmationService, MessageService } from 'primeng/api';
import { Subject, takeUntil } from 'rxjs';
import { AppMainService } from 'src/app/app-main.service';
import { CookieStoreService } from 'src/app/modules/shared/services/cookie-store.service';
import { AccountUserService } from 'src/app/service/account.service';
import { PermissionService } from 'src/app/service/permission.service';
import { AuthenticationSetupModel, ResendOTP } from '../../models/authenticatonSetup.models';
import { emailValidator } from 'src/app/modules/shared/validators/email.validator';
import { jsPDF } from "jspdf";
import { RobotoFont } from 'src/app/inventory/sales-order/utils/vfs';
import { environment } from 'src/environments/environment';


@Component({
  selector: 'app-authentication-setup',
  templateUrl: './authentication-setup.component.html',
  styleUrls: ['./authentication-setup.component.scss']
})
export class AuthenticationSetupComponent implements OnInit, OnChanges, OnDestroy{

  @ViewChild('printableArea') printableArea: ElementRef;
  assestBaseUrl: string = environment.assestsBasePath;
  returnUrl = "";
  resendTimer: number = 120; // 2 minutes in seconds
  timerInterval: any;
  resendButtonDisabled: boolean = true;
  rememberSetUp:any;
  //login Authenticator
  displayAuthenPage: boolean = false

  verification: string;
  pageLogin = false;
  @Input() authenticationSetup: boolean = false;
  @Input() authenticationData: any;
  @Input() loginFormData: any;
  authenticationPage: boolean = false;
  displayAuthentication = false;
  displaySMS: boolean = false;
  displayEmail: boolean = false;
  verificationCode: number;
  mfaMessage: string = "";
  mfaType: string = "";
  mfaKey: string = "";
  enteredCode: number;
  displayResetupAuthen: boolean = false;
  enterBackupCode: any;
  authenEmailId: any = "";
  showCopyMessage: boolean = false;

  finalAuthenticationSetup: boolean = false;
  secondStepAuthenticationSetup: boolean = false;
  displayBackupCode: boolean;
  recoveryCode: string = "";
  authenticationSetupData: any;
  countryData: any;
  selectedCountry: any = "";
  finalLoginData: any;  //login data after showing backup code ;
  authenticationSetupForm: FormGroup;
  manualSetupKey: string = "";

  verificationOptions: any[] = [];

  @Output() authenSetupBackClicked: EventEmitter<void> = new EventEmitter<void>();
  @Output() onSubmitAuthnPage: EventEmitter<number> = new EventEmitter<number>();
  @Output() onReSetupAuthen: EventEmitter<any> = new EventEmitter<any>();

  /* Subject to unsubscribe */
  private ngUnsubscribe = new Subject<void>();
  constructor(
    private formBuilder: FormBuilder,
    private accountService: AccountUserService,
    public appMainService: AppMainService,
    private messageService: MessageService,
    private permissionService: PermissionService,
    private cookieStoreService: CookieStoreService,
    private route: ActivatedRoute,
    private router: Router,
    private confirmationService: ConfirmationService) {

  }

  ngOnInit(): void {
    let routeValue = this.route.snapshot.queryParams;
    this.returnUrl = routeValue?.returnUrl || null;
    this.authenticationSetupDropdown();
  }
  ngOnChanges(changes: SimpleChanges): void {
    if (changes?.authenticationData?.currentValue) {
      this.authenticationData = changes.authenticationData.currentValue;
      this.prepareAuthenticationSetupForm(this.authenticationData);
    }
    if (changes?.loginFormData?.currentValue) {
      this.loginFormData = changes.loginFormData.currentValue;

    }

  }

  initAuthenticationSetupForm() {
    this.authenticationSetupForm = this.formBuilder.group({
      verification: ["", Validators.required],
      qrCodeSrc: [""],
      phoneNumber: [""],
      email: [""],
      verificationCode: [null, Validators.required]
    });

  }

  authenticationSetupDropdown() {
    this.verificationOptions = [
      { label: 'Authentication App', value: 'AuthenticatorApp', description: 'Retrieve codes from an authentication app (such as Microsoft Authenticator or Google Authenticator) on your mobile device.' },
      // { label: 'SMS Text Message', value: 'SMS', description: 'Receive a text message to your mobile device when signing in.' },
      { label: 'Email', value: 'Email', description: 'Receive an Email when signing in.' }
    ];
  }

  prepareAuthenticationSetupForm(authenticationData: any) {
    if (!authenticationData.IsMFAByPass) {
      this.displayAuthenPage = true;
      if (authenticationData.IsSuccess) {
        if (authenticationData.IsMFAEnabled) {
          this.mfaType = authenticationData.MFAType;
          this.mfaMessage = authenticationData.MFAMessage;
          this.mfaKey = authenticationData.MFAkey;
          this.resendTimer = 120;
          this.authenticationSetup = false;
          this.authenticationPage = true;
          this.authenEmailId = authenticationData.login?.EmailId
          this.startTimer();

        } else {
          this.clearFeilds();
          this.authenticationSetup = true;
        }
        this.initAuthenticationSetupForm();
      }
    } else {
      // Bypass auhtentication direct login
      this.loginWithoutAuthen(authenticationData);
    }
  }

  //#region authentication setup & authentication page back buttton

  onBackClicked() {
    this.authenticationSetup = false;
    this.authenSetupBackClicked.emit();
  }

  onSubmitAuthenPage() {
    this.authenticationData.MFAVerificationCode = this.enteredCode;
    this.loginMethod(this.authenticationData);
  }

  showError(msg) {
    this.messageService.add({ severity: 'error', summary: 'Error', detail: msg });
  }

  //#endregion authentication setup & authentication page back buttton

  //authentication
  next() {
    this.secondStepAuthenticationSetup = true;
    const mfaType = this.authenticationSetupForm.get('verification').value;
    switch (mfaType) {
      case 'AuthenticatorApp':
        this.displayAuthentication = true;
        this.authenticatorAppSetUp(this.authenticationData);
        break;
      case 'SMS':
        this.displaySMS = true;
        this.getCountryCode();
        break;
      case 'Email':
        this.displayEmail = true;
        this.authenticationSetupForm.get('email').setValue(this.loginFormData.emailId);
        break;
      default:
        break;
    }
    this.authenticationSetup = false;
  }

  concatenatePhoneNumber(phoneNumber: string): string {
    if (this.selectedCountry && this.selectedCountry.PhoneCode) {
      return `+${this.selectedCountry.PhoneCode}-${phoneNumber}`;
    }
    return phoneNumber; // Return only phone number if country or phone code is not selected
  }


  authenticatorAppSetUp(authenticationData: any) {
    const emialId = this.authenticationSetupForm?.get('email')?.value;
    const phoneNumber = this.concatenatePhoneNumber(this.authenticationSetupForm?.get('phoneNumber')?.value) || "";
    let authenSetupData: AuthenticationSetupModel = {
      mfaKey: emialId || phoneNumber,
      mfaType: "primary",
      mfaMethod: this.authenticationSetupForm?.get('verification')?.value,
      login: authenticationData.login
    }
    this.appMainService.isShowSpinner('authenSetUp');
    this.accountService.setUpAuthen(authenSetupData).pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(
        {
          next: (response) => {
            if(authenSetupData.mfaMethod === 'SMS'){
              this.secondStepAuthenticationSetup = false;
              this.finalAuthenticationSetup = true;
            }
            this.authenticationSetupData = response;
            this.recoveryCode = this.authenticationSetupData.RecoveryCode;

            this.manualSetupKey = this.authenticationSetupData.ManualSetupKey;
            this.authenticationSetupForm.patchValue({
              qrCodeSrc: this.authenticationSetupData.QrCodeImageData
            });
            this.appMainService.isHideSpinner('authenSetUp');

            if(phoneNumber || emialId){
              this.messageService.add({
                severity: "success",
                summary: "Success",
                detail: `Verification Code has been sent Successfully`,
              });
            }
          },
          error: (error) => {
            this.appMainService.isHideSpinner('authenSetUp');
            this.messageService.add({
              severity: 'error',
              summary: 'Error',
              detail: error?.error?.message ? error?.error?.message : error.error.message});

          },
          complete: () => { },
        });


  }

  //#region final login method
  loginMethod(authenticationData) {
    this.appMainService.isShowSpinner('authentication');
    authenticationData.IsRemember = this.rememberSetUp;
    this.accountService.verifyLogin(authenticationData)
      .then(users => {
        if (users.isSuccess) {
          this.appMainService.isShowSpinner('UserPemissions');
          this.accountService.updateUserTimeZone();
          this.permissionService.getUserPermissions(users).subscribe(
            resp => {
              this.appMainService.isHideSpinner('UserPemissions');
              this.returnUrl = this.returnUrl || users?.userLangingPage;
              this.router.navigateByUrl(this.returnUrl);
              if (this.rememberSetUp) {
                const emailId = this.loginFormData.emailId.toLowerCase();
                const isRememberKey = users.RKey;
                let dataList: any[] = this.cookieStoreService.getDecryptedBypassAuthenticationData() || [];

                const existingIndex = dataList.findIndex(item => item.emailId === emailId);

                if (existingIndex !== -1) {
                  dataList[existingIndex].isRememberKey = isRememberKey;
                } else {
                  dataList.push({ emailId, isRememberKey });
                }
                this.cookieStoreService.setBypassAuthenticationCookie(dataList);
              }

              if (this.loginFormData.rememberMe) {
                const emailId = this.loginFormData.emailId
                // Set the emailID in a cookie in encrypted form
                this.cookieStoreService.setRememberMeEmailCookie(emailId);
              } else {
                // If the checkbox is unchecked, remove the cookie
                this.cookieStoreService.delete('emailId');
              }
              this.authenticationPage = false;
            },
            err => {
              this.appMainService.isHideSpinner('UserPemissions');
            }
          )

        }
        else
          this.showError(users.reason);
        this.appMainService.isHideSpinner('authentication');
      }).catch(err => {
        this.appMainService.isHideSpinner('authentication');

        this.messageService.add({ severity: 'error', summary: 'Error', detail: err.error.message ? err.error.message :'Please enter 6 digit code' });
      });
  }



  // back button level 2 of authentication setup
  onAuhtenSetupBackButton() {
    this.secondStepAuthenticationSetup = false;
    this.authenticationSetup = true;
    this.manageAuthenDisplay();
    this.clearFormControl();
  }

  onAuthenSetupNextButton() {
    clearInterval(this.timerInterval);
    const mfaType = this.authenticationSetupForm.get('verification').value;
    switch (mfaType) {
      case 'SMS':
      case 'Email':
        this.authenticatorAppSetUp(this.authenticationData);
        this.resendTimer = 120;
        this.startTimer();
        if (mfaType === 'Email') {
          this.secondStepAuthenticationSetup = false;
          this.finalAuthenticationSetup = true;
        }
        break;

      case 'AuthenticatorApp':
        this.secondStepAuthenticationSetup = false;
        this.finalAuthenticationSetup = true;
        break;

      default:
        break;
    }
  }


  manageAuthenDisplay() {
    const selectedMfaType = this.authenticationSetupForm.get('verification').value;
    switch (selectedMfaType) {
      case 'AuthenticatorApp':
        this.displayAuthentication = false;
        break;
      case 'SMS':
        this.displaySMS = false;
        break;
      case 'Email':
        this.displayEmail = false;
        break;
      default:
        break;
    }
  }

  lastBackButton() {
    clearInterval(this.timerInterval);
    this.finalAuthenticationSetup = false;
    this.authenticationSetupForm.get('verificationCode').reset();
    this.updateDataBackButton();
  }

  onClickDone() {
    this.loginAfterAuthenticationSetup();
  }

  onDoneBackupCode() {
    this.displayBackupCode = false;
    this.returnUrl = this.returnUrl || this.finalLoginData?.userLangingPage;
    this.router.navigateByUrl(this?.returnUrl);

    if (this.loginFormData?.rememberMe) {
      const emailId = this.loginFormData?.emailId
      // Set the emailID in a cookie in encrypted form
      this.cookieStoreService.setRememberMeEmailCookie(emailId);
    } else {
      // If the checkbox is unchecked, remove the cookie
      this.cookieStoreService.delete('emailId');
    }

  }

  copyBackupCode() {
    // Create a temporary input element to hold the text to be copied
    const tempInput = document.createElement("input");
    tempInput.value = this.recoveryCode;
    document.body.appendChild(tempInput);

    // Select the text in the input element
    tempInput.select();
    tempInput.setSelectionRange(0, 99999); // For mobile devices

    // Copy the selected text to the clipboard
    document.execCommand("copy");

    // Remove the temporary input element
    document.body.removeChild(tempInput);
    this.showCopyMessage = true;

    // Hide the "Text copied" message after a certain duration
    setTimeout(() => {
      this.showCopyMessage = false;
    }, 2000);

    // Set the tooltip to show "Text copied"
    const copyIcon = document.querySelector('.pi-copy');
    copyIcon.setAttribute('title', 'Text copied');
  }

  copyManualSetupKey() {
    // Remove spaces from the manualSetupKey
    const manualSetupKeyWithoutSpaces = this.manualSetupKey.replace(/\s+/g, '');

    const el = document.createElement('textarea');
    el.value = manualSetupKeyWithoutSpaces;
    document.body.appendChild(el);

    // Select and copy the value to the clipboard
    el.select();
    document.execCommand('copy');

    // Remove the temporary textarea element
    document.body.removeChild(el);
    this.showCopyMessage = true;

    // Hide the "Text copied" message after a certain duration
    setTimeout(() => {
      this.showCopyMessage = false;
    }, 2000); // Adjust the duration as needed

    const copyIcon = document.querySelector('.pi-copy');
    copyIcon.setAttribute('title', 'Text copied');
  }

  // #region resend OTP and re-set authentication
  resend() {
    this.resendTimer = 120; // Reset the timer to 2 minutes
    this.startTimer(); // Start the timer again
    const mfaMethod = this.authenticationSetupForm.get('verification').value;
    const resendOtp: ResendOTP = {
      loginAuditId: this.authenticationSetupData.LoginAuditId,
      configId: this.authenticationSetupData.ConfigId,
      mFAJournalId: this.authenticationSetupData.MFAJournalId,
      mfaMethod: mfaMethod,
      login: this.authenticationSetupData.login
    }
    this.appMainService.isShowSpinner('resend');
    this.accountService.resendOtp(resendOtp).pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(
        {
          next: (response) => {
            this.appMainService.isHideSpinner('resend');
            this.messageService.add({
              severity: 'success',
              summary: 'Success',
              detail: 'Code has been resent successfully.'
            });
          },
          error: (error) => {
            this.appMainService.isHideSpinner('resend');
            this.messageService.add({
              severity: 'error',
              summary: 'Error',
              detail: error?.error?.message ? error?.error?.message : ' please try again...'
            });

          },
          complete: () => { },
        });
  }

  reSetupAuthen() {
    this.displayResetupAuthen = true;

  }

  //#region Re-setup authenenticaton
  onSubmitReSetup() {
    const reSetupAuthen: any = {
      userId: this.authenticationData.UserId,
      recoveryCode: this.enterBackupCode
    }
    this.confirmationService.confirm({
      message: 'Are you sure you want to Re-Set Authentication?',
      header: 'Confirmation',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        // User confirmed, execute API call
        this.executeReSetupAuthen(reSetupAuthen);
      },
      reject: () => { }
    });
  }

  executeReSetupAuthen(reSetupAuthen) {
    this.appMainService.isShowSpinner('authenSetUp');
    this.accountService.reSetupAuthen(reSetupAuthen).pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(
        {
          next: (response) => {
            this.authenticationPage = false;
            this.displayResetupAuthen = false;
            this.displayAuthenPage = false;
            this.onReSetupAuthen.emit({ success: true, output: "submit" });
            this.appMainService.isHideSpinner('authenSetUp');
          },
          error: (error) => {
            this.appMainService.isHideSpinner('authenSetUp');
            this.messageService.add({
              severity: 'error',
              summary: 'Error',
              detail: error?.error?.message ? error?.error?.message : 'Re-Set Authentication failed, please try again...'
            });

          },
          complete: () => {},
        });
  }

  //#endregion resend OTP and re-set authentication

  //#region final login after authenticationsetup
  loginAfterAuthenticationSetup() {
    this.appMainService.isShowSpinner('authentication');
    const verificationCode = this.authenticationSetupForm.get('verificationCode').value;
    this.authenticationSetupData.MFAVerificationCode = verificationCode;
    this.authenticationSetupData.QrCodeImageData = "";
    this.authenticationSetupData.ManualSetupKey = "";
    this.authenticationSetupData.RecoveryCode = "";
    this.appMainService.isShowSpinner('authentication');
    this.accountService.verifyAuthenSetUpLogin(this.authenticationSetupData)
      .then(users => {
        if (users.isSuccess) {
          this.appMainService.isShowSpinner('UserPemissions');
          this.accountService.updateUserTimeZone();
          this.permissionService.getUserPermissions(users).subscribe({
            next:(response) =>{
              this.displayAuthenPage =  false;
              this.displayBackupCode = true;
              this.finalLoginData = users;
              this.appMainService.isHideSpinner('UserPemissions');
            },
            error:(error)=>{
              this.appMainService.isHideSpinner('UserPemissions');
            },
            complete: () => { },
          });
        }
        else{
          this.showError(users.reason);
        this.appMainService.isHideSpinner('authentication');
        }
      }).catch(err => {
        this.appMainService.isHideSpinner('authentication');

        this.messageService.add({ severity: 'error', summary: 'Error', detail: err.error.message });
      })
      .finally(() => {
        this.appMainService.isHideSpinner('authentication');
      });
  }
  //#endregion final login after authenticationsetup

  getCountryCode() {
    this.accountService.countryCode().pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(
        {
          next: (response) => {
            this.countryData = response;
          },
          error: (error) => {
            this.appMainService.isHideSpinner('authenSetUp');
            this.messageService.add({
              severity: 'error',
              summary: 'Error',
              detail: error?.error?.message ? error?.error?.message : 'please try again...'
            });

          },
          complete: () => { },
        });
  }

  onCountrySelect(event: any) {
    this.selectedCountry = event.value;
  }

  clearFeilds() {
    this.enteredCode = null;
  }

  backAuthenPage() {
    clearInterval(this.timerInterval);
    this.authenticationPage = false;
    this.displayAuthenPage = false;
    this.enteredCode = null;
    this.onReSetupAuthen.emit({success: true, output: "back"});
  }

  loginWithoutAuthen(loginData: any) {
    const data = this.accountService.authenticationSetupDirect(loginData);
    this.appMainService.isShowSpinner('UserPemissions');
    this.accountService.updateUserTimeZone();
    this.permissionService.getUserPermissions(data).subscribe(
      resp => {
        this.appMainService.isHideSpinner('UserPemissions');
        this.returnUrl = this.returnUrl || data?.userLangingPage;
        this.router.navigateByUrl(this.returnUrl);

        if (this.loginFormData.rememberMe) {
          const emailId = this.loginFormData.emailId
          // Set the emailID in a cookie in encrypted form
          this.cookieStoreService.setRememberMeEmailCookie(emailId);
        } else {
          // If the checkbox is unchecked, remove the cookie
          this.cookieStoreService.delete('emailId');
        }
        this.authenticationPage = false;
      },
      err => {
        this.appMainService.isHideSpinner('UserPemissions');
      }
    )
  }

  //#region for phonenumber and email validation
  isEmailOrPhoneNumberEmpty() {
    this.authenticationSetupForm.get('verification').valueChanges.subscribe(value => {
      if (value === 'AuthenticatorApp') {
        this.authenticationSetupForm.get('email').clearValidators();
        this.authenticationSetupForm.get('phoneNumber').clearValidators();
      } else if (value === 'SMS') {
        this.authenticationSetupForm.get('email').clearValidators();
        this.authenticationSetupForm.get('phoneNumber').setValidators([Validators.required, Validators.pattern(/^\d+$/)]);
      } else if (value === 'Email') {
        this.authenticationSetupForm.get('phoneNumber').clearValidators();
        this.authenticationSetupForm.get('email').setValidators([Validators.required, emailValidator]);
      }

    });
    // Update validators
    this.authenticationSetupForm.get('email').updateValueAndValidity();
    this.authenticationSetupForm.get('phoneNumber').updateValueAndValidity();
    this.authenticationSetupForm.get('verification').updateValueAndValidity();
  }

  onSelectAuthenType() {
    this.isEmailOrPhoneNumberEmpty();
  }

  clearFormControl() {
    const selectedVerificationMethod = this.authenticationSetupForm.get('verification').value;

    switch (selectedVerificationMethod) {
      case  'AuthenticatorApp':
        this.selectedCountry.PhoneCode = "";
        break;

      case 'SMS':
        this.authenticationSetupForm.get('phoneNumber').reset();
        this.selectedCountry.PhoneCode = "";
        break;
      case 'Email':
        this.authenticationSetupForm.get('email').reset();
        break;
      default:
        break;
    }
  }

  downloadPDF() {
    let pdf = new jsPDF("p", "pt", "a4", true);
    pdf.addFileToVFS("Roboto-Regular.ttf", RobotoFont);
    pdf.addFont("Roboto-Regular.ttf", "Roboto-Regular", "normal");
    pdf.setFont("Roboto-Regular");

    let html = document.getElementById("printableArea").innerHTML;
    html = html.replace(/width="100%"/, 'width="555"');
    pdf.html(html, {
      callback: function (pdf) {
          pdf.save("recoverycode.pdf");
      },
      margin: [40, 20],
    });

  }

  resendOTP(){
    this.resendTimer = 120; // Reset the timer to 2 minutes
    this.startTimer(); // Start the timer again
    const resendOtp: ResendOTP = {
      loginAuditId: this.authenticationData.LoginAuditId,
      configId: this.authenticationData.ConfigId,
      mFAJournalId: this.authenticationData.MFAJournalId,
      mfaMethod: this.authenticationData.MFAType,
      login: this.authenticationData.login
    }
    this.appMainService.isShowSpinner('resend');
    this.accountService.resendOtp(resendOtp).pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(
        {
          next: (response) => {
            this.appMainService.isHideSpinner('resend');
            this.messageService.add({
              severity: 'success',
              summary: 'Success',
              detail: 'Code has been resent successfully.'
            });
          },
          error: (error) => {
            this.appMainService.isHideSpinner('resend');
            this.messageService.add({
              severity: 'error',
              summary: 'Error',
              detail: error?.error?.message ? error?.error?.message : 'Please try again...'
            });

          },
          complete: () => { },
        });
  }

  updateDataBackButton() {
    this.secondStepAuthenticationSetup = true;
    const mfaType = this.authenticationSetupForm.get('verification').value;
    switch (mfaType) {
      case 'AuthenticatorApp':
        this.displayAuthentication = true;
        break;
      case 'SMS':
        this.displaySMS = true;
        break;
      case 'Email':
        this.displayEmail = true;
        break;
      default:
        break;
    }
    this.authenticationSetup = false;
  }

  preventSpace(event: KeyboardEvent) {
    if (event.key === ' ') {
        event.preventDefault();
    }
  }

  startTimer() {
    this.resendButtonDisabled = true;
    this.timerInterval = setInterval(() => {
        if (this.resendTimer > 0) {
            this.resendTimer--;
        } else {
            clearInterval(this.timerInterval);
            this.resendButtonDisabled = false; // Stop the timer when it reaches 0
        }
    }, 1000); // Update the timer every second
  }

  // Function to format the remaining time in minutes and seconds
  formatTimer() {
      const minutes = Math.floor(this.resendTimer / 60);
      const seconds = this.resendTimer % 60;
      return `${minutes}:${seconds < 10 ? '0' : ''}${seconds}`;
  }

  onCancelResetAuthen(){
    this.displayResetupAuthen = false;
    this.enterBackupCode = "";
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

}
